<template>
  <div class="image-upload">
    <div class="img-list">
      <div class="item" :key="index" v-for="(item, index) in imageList">
        <img
          class="img"
          :src="
            item.url && item.url.indexOf('http') != -1
              ? item.url
              : FILEBASEURL + item.url
          "
          alt=""
        />
        <span class="del" @click="delImg(index)">
          <van-icon name="clear" color="#A9A9B7" />
        </span>
      </div>
    </div>

    <div class="upload">
      <van-uploader :after-read="fileAfterRead" :max-count="1">
        <div class="btn">
          <van-icon name="photo-o" size="20" />
          <span class="text">图片</span>
        </div>
      </van-uploader>
    </div>
  </div>
</template>

<script>
import Compressor from "compressorjs";
import { ref, toRefs } from "vue";
import { useStore } from "vuex";
import { Toast } from "vant";
export default {
  name: "ImageUpload",
  components: {},
  props: {
    moduleName: {
      type: String,
      default: "studentLeave",
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const FILEBASEURL = ref(process.env.VUE_APP_BASE_File_URL);

    const { list } = toRefs(props);
    const { moduleName } = toRefs(props);

    const imageList = ref(list.value || []);
    const uploadOSS = (params) => store.dispatch("common/uploadOSS", params);

    const compressFile = (file) => {
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          convertSize: 500000,
          success(result) {
            resolve(result);
          },
          error(err) {
            console.log(err.message);
          },
        });
      });
    };

    const fileAfterRead = async (file) => {
      let result = await compressFile(file.file);
      let r = await uploadOSS({
        file: result,
        moduleName: moduleName.value,
      });
      if (r.success) {
        let { id, url } = r.data;
        let temp = {
          id: id,
          url: url,
          file: result,
        };
        imageList.value.push(temp);
        emit("change", imageList.value);
      } else {
        Toast.fail("文件上传失败，请重新上传！");
      }
    };

    const delImg = (index) => {
      imageList.value.splice(index, 1);
      emit("change", imageList.value);
    };

    return {
      FILEBASEURL,
      imageList,
      fileAfterRead,
      delImg,
    };
  },
};
</script>

<style lang="less" scoped>
.image-upload {
  box-sizing: border-box;
  min-height: 54px;
  padding: 11px 15px;
  background: #ffffff;
  box-shadow: inset 0px 1px 0px 0px #e5e5e5;
}
.img-list {
  .item {
    position: relative;
    display: inline-block;
    width: 72px;
    height: 72px;
    margin: 8px;
    border-radius: 2px;
    .img {
      width: 100%;
      height: 100%;
      border-radius: 2px;
      overflow: hidden;
    }
    .del {
      position: absolute;
      right: -10px;
      top: -10px;
      padding: 5px;
    }
  }
}
.upload {
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90px;
    height: 32px;
    color: #333;
    font-size: 15px;
    font-weight: 400px;
    background: #ffffff;
    border-radius: 18px;
    border: 1px solid #e5e5e5;
    .text {
      margin-left: 8px;
    }
  }
}
</style>
